// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let DialogV5 = require("../common/Components/DialogV5.bs.js");
let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let JsxRuntime = require("react/jsx-runtime");

let propertyOnlyMatches = JsxRuntime.jsxs("div", {
  children: [
    JsxRuntime.jsxs("p", {
      children: [
        JsxRuntime.jsx("span", {
          children: "By selecting this option you will"
        }),
        JsxRuntime.jsx("strong", {
          children: " only "
        }),
        JsxRuntime.jsx("span", {
          children: "get property emails that match either:"
        })
      ]
    }),
    JsxRuntime.jsx("p", {
      children: "1) Buyer needs you have broadcast on TAN"
    }),
    JsxRuntime.jsx("p", {
      children: "2) Buyers you have entered as Private Matches"
    })
  ],
  className: "flex flex-col space-y-5"
});

let rentalPropertyOnlyMatches = JsxRuntime.jsx("div", {
  children: JsxRuntime.jsxs("p", {
    children: [
      JsxRuntime.jsx("span", {
        children: "By selecting this option you will"
      }),
      JsxRuntime.jsx("strong", {
        children: " only "
      }),
      JsxRuntime.jsx("span", {
        children: "get rental property emails that match rental needs that you have broadcast on TAN"
      })
    ]
  })
});

let buyerNeedOnlyMatches = JsxRuntime.jsxs("div", {
  children: [
    JsxRuntime.jsxs("p", {
      children: [
        JsxRuntime.jsx("span", {
          children: "By selecting this option you will"
        }),
        JsxRuntime.jsx("strong", {
          children: " only "
        }),
        JsxRuntime.jsx("span", {
          children: "get buyer need emails that match either:"
        })
      ]
    }),
    JsxRuntime.jsx("p", {
      children: "1) Properties you have broadcast on TAN"
    }),
    JsxRuntime.jsx("p", {
      children: "2) Sellers you have entered as Private Matches"
    })
  ]
});

let rentalNeedOnlyMatches = JsxRuntime.jsx("div", {
  children: JsxRuntime.jsxs("p", {
    children: [
      JsxRuntime.jsx("span", {
        children: "By selecting this option you will"
      }),
      JsxRuntime.jsx("strong", {
        children: " only "
      }),
      JsxRuntime.jsx("span", {
        children: "get rental need emails that match rental properties that you have broadcast on TAN"
      })
    ]
  })
});

function getDialogContent(x) {
  switch (x) {
    case "PropertyOnlyMatches" :
      return propertyOnlyMatches;
    case "RentalPropertyOnlyMatches" :
      return rentalPropertyOnlyMatches;
    case "BuyerNeedOnlyMatches" :
      return buyerNeedOnlyMatches;
    case "RentalNeedOnlyMatches" :
      return rentalNeedOnlyMatches;
  }
}

function NotificationSettingsEntitySettingConfirmationModal(props) {
  let onCancel = props.onCancel;
  let onConfirm = props.onConfirm;
  return JsxRuntime.jsxs(DialogV5.make, {
    title: "Are you sure?",
    isOpen: props.isOpen,
    ariaLabel: "Are you sure?",
    onDismiss: onCancel,
    children: [
      getDialogContent(props.confirmationType),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(ButtonsV5.LinkButton.make, {
            onClick: param => onCancel(),
            children: "Cancel"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
              onClick: param => onConfirm(),
              children: "Yes, I understand"
            }),
            className: "ml-5"
          })
        ],
        className: "flex justify-end items-center mt-8"
      })
    ]
  });
}

let make = NotificationSettingsEntitySettingConfirmationModal;

exports.propertyOnlyMatches = propertyOnlyMatches;
exports.rentalPropertyOnlyMatches = rentalPropertyOnlyMatches;
exports.buyerNeedOnlyMatches = buyerNeedOnlyMatches;
exports.rentalNeedOnlyMatches = rentalNeedOnlyMatches;
exports.getDialogContent = getDialogContent;
exports.make = make;
/* propertyOnlyMatches Not a pure module */
